import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { isCommercialTermsProduct } from '@weft/services';
import type { FixedProductInput } from '@weft/types';
import { withDefault } from '@weft/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import type { NewPlanForm } from '../../../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';
import { getDefaultCommercialTermsProduct, getDefaultFixedPerUnitProduct, getDefaultFixedProduct, getDefaultRefundProduct } from '../../../../../plans/CreatePlanPage/create-plan-page-consts/add-item-button-consts';

export const CreateInvoicePageFixedChargesMenuItems: React.FC = () => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();

  const fixedProducts = withDefault(getValues('fixedProducts'), []);
  const commercialTermsProducts = fixedProducts.filter(isCommercialTermsProduct);
  const doesPlanHaveCommercialTerms = commercialTermsProducts.length > 0;

  const handleProductClick = (defaultProductCallback: () => FixedProductInput) => {
    return () => {
      const currentProducts = getValues('fixedProducts') ?? [];
      const defaultProduct = defaultProductCallback();
      const updatedProducts = [...currentProducts, defaultProduct];
      setValue('fixedProducts', updatedProducts);
    };
  };

  return (
    <>
      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultFixedProduct)}
      >
        <Typography className="text-sm font-normal text-black">One Time Fee</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Single one time charge</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultCommercialTermsProduct)}
        disabled={doesPlanHaveCommercialTerms}
      >
        <Typography className="text-sm font-normal text-black">Commercial Terms</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Contract commitment</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultFixedPerUnitProduct)}
      >
        <Typography className="text-sm font-normal text-black">Per Unit Pricing</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Fixed fee per unit</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultRefundProduct)}
      >
        <Typography className="text-sm font-normal text-black">Refund</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">One time refund amount</Typography>
      </MenuItem>
    </>
  );
};